import { useActiveRoute, usePendingRoute } from "../../logic/stores/navigationStore.js";
import { getRouteSkeleton } from "./routeSkeletonRegistry.js";

/** Route-transition skeleton — layout matches the pending (or active) route. */
export function RoutePageSkeleton() {
  const active = useActiveRoute();
  const pending = usePendingRoute();
  const Skeleton = getRouteSkeleton(pending ?? active);
  return <Skeleton />;
}
